export enum QueryKey {
  providersInfo = "providersInfo",
  validatorList = "validatorList",
  nodes = "nodes",
  addressPair = "addressPair",
  earningsData = "earningsData",
}

export enum TransactionType {
  IMPORT_TX = "IMPORT_TX",
  EXPORT_TX = "EXPORT_TX",
  ADD_VALIDATOR_TX = "ADD_VALIDATOR_TX",
  ADD_DELEGATOR_TX = "ADD_DELEGATOR_TX",
  ADVANCE_TIME_TX = "ADVANCE_TIME_TX",
  REWARD_TX = "REWARD_TX",
  empty = "empty",
}

export enum EarningsProtocolType {
  NONE = "None",
  STAKE = "Stake",
  DELEGATION = "Delegation",
}
